import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import {
  ResellerResponse,
  UpdateResellerData
} from '@utils/types/organization/reseller.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';

export const useUpdateResellerCustomer = () => {
  const queryClient = useQueryClient();

  const updateResellerCustomer = ({
    customerId,
    data
  }: {
    customerId: string;
    data: UpdateResellerData;
  }) =>
    Axios.put<ResellerResponse>(
      PUT_URL(customerId).updateResellerCustomer,
      data
    ).then(res => res.data);

  return useMutation<
    ResellerResponse,
    AxiosError<BaseError>,
    { customerId: string; data: UpdateResellerData }
  >(updateResellerCustomer, {
    onSuccess: (_data, req) => {
      queryClient.invalidateQueries(QueryKeys.reseller(req.customerId));
      queryClient.invalidateQueries(['reseller']);
    },
    useErrorBoundary: false
  });
};
